import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input } from '@angular/core';

import { IconComponent } from '../../../common/icon/icon.component';
import { ComponentVariant, Variants } from '../../variant/variant';

@Component({
  selector: 'rt-dropdown-item',
  templateUrl: './dropdown-item.component.html',
  styleUrls: ['./dropdown-item.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.is-parent]': 'isParent',
    '[class.has-symbol]': 'symbol || icon',
    '[class.highlighted]': 'highlighted',
    '[class.align-top]': 'alignTop',
    '[class.padding-small]': 'paddingSmall',
    '[class.padding-lr-small]': 'hasHorizontalPaddingSmall',
    '[class.white-text]': 'textColorWhite',
    '[class.has-text-color-border]': 'hasTextColorBorder',
    '[class.font-weight-medium]': 'fontWeightMedium',
    '[class.flex-column]': 'flexColumn',
    '[class.no-hover-effect]': '!hasHoverEffect',

    '[class.has-divider]': 'hasDivider',
    '[class]': 'variant',
  },
})
export class DropdownItemComponent {
  public static readonly VARIANTS: Variants = [
    'default',
    [
      'default',
      'plain',
      'no-icon',
      'no-padding',
      'footer',
      'padding-small-x',
      'icon-right',
      'full-width',
      'cursor-auto',
      'white',
    ],
  ];
  @ComponentVariant(DropdownItemComponent.VARIANTS)
  @Input()
  public variant: string;
  @ContentChild(IconComponent)
  public icon: IconComponent;
  @ContentChild('symbol') public symbol: any;
  @Input() public href: boolean | string = false;
  @Input() public hrefTarget: string | null;
  @Input() public highlighted: boolean;
  @Input() public isParent: boolean;
  @Input() public alignTop: boolean = false;
  @Input() public paddingSmall: boolean = false;
  @Input() public textColorWhite: boolean = false;
  @Input() public fontWeightMedium: boolean = false;
  @Input() public hasHorizontalPaddingSmall: boolean = false;
  @Input() public hasTextColorBorder: boolean = false;
  @Input() public noDivider: boolean = false;

  @Input() public flexColumn: boolean = false;
  @Input() public hasHoverEffect: boolean = true;
  @Input() public hasSymbol: boolean = true;
  @Input() public hasDivider: boolean = false;
  @Input() public hasChevronRight: boolean = false;

  constructor(public elRef: ElementRef) {}
}
